import { render } from "./AskDelays.vue?vue&type=template&id=2cb91ba1&scoped=true"
import script from "./AskDelays.vue?vue&type=script&lang=js"
export * from "./AskDelays.vue?vue&type=script&lang=js"

import "./AskDelays.vue?vue&type=style&index=0&id=2cb91ba1&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb91ba1"]])

export default __exports__